import React, { useEffect, useState } from "react"
import TextBox from 'devextreme-react/text-box';
import { TextArea} from 'devextreme-react';
import SelectBox from "../../../../common/CustomSelectBox"
import { DocumentationRequestTypes, DocumentationRequestWithSubtypes } from "../../../../../Constantes/documentataionRequestTypes";
import CheckBox from 'devextreme-react/check-box';
import { baseRequest } from "../../../../../fetch/basicThunk";
import { QUERY_GET_ITVS_BY_POSTAL_CODE, QUERY_GET_PROVINCE_BY_POSTALCODE } from "../../../../../fetch/constantQueries";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../../../redux/modal/modalSlice";
import { selectDocumentationRequestTemplates, selectDocumentationRequestTemplatesLoading } from "../../../../../redux/documentationRequestTemplates/selectors";
import { getDocumentationRequestTemplates } from "../../../../../redux/documentationRequestTemplates/thunks";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getFactoryITVBond } from "../../../../../redux/factoryItvBond/thunks";
import { selectContract } from "../../../../../redux/contract/selectors";
import { selectITVBondInfo } from "../../../../../redux/factoryItvBond/selectors";
import { clearITVBondInfo } from "../../../../../redux/factoryItvBond/factoryITVBondSlice";
import { factoryActive } from "../../../../../Constantes/factoryActive";

function DocumentationRequestForm(props){
const {classes, onChange, dataForm} = props;
const [stations, setStations] = useState([])
const dispatch = useDispatch();
const types = useSelector(selectDocumentationRequestTemplates);
const typesLoading = useSelector(selectDocumentationRequestTemplatesLoading);
const contract = useSelector(selectContract);
const itvBondInfo = useSelector(selectITVBondInfo);
const zoneTypes=["Madrid","Barcelona","Otros"];
const originalVhTypes =["Itv", "Extranjero", "Zona de seguridad"]
const aafTypes = ["Si", "Junta Extremadura"]
const itvTypes = ["ITV", "ITV SC (Galicia)"]
const costExcemptTypes = ["Sí", "No"]
const producerBookSubtypes = [{name: "No entregado", code: "producer_book_not_given"}, {name: "Extraviado", code: "producer_book_lost"}, {name: "MTR", code: "producer_book_mtr"}];
const accidentRateSubtypes = [{name: "Vh. vigente NO MTR", code: "no_accident_rate_certificate"}, {name: "Vh. vigente MTR", code: "no_accident_rate_certificate_mtr"}, {name: "Vh. baja", code: "no_accident_rate_certificate_inactive"}];
const [mtrSubtypes, setMtrSubtypes ] = useState([{name: "No MTR", code: `${type}`}, {name: "MTR", code: `${type}_mtr`}]);
const [type, setType] = useState(dataForm?.templateCode)


useEffect(()=>{
    dispatch(getDocumentationRequestTemplates())  
},[])

useEffect(()=>{
    if(dataForm?.postalCode && (!stations || stations.length ==0)){
        setProvince();
    }
},[])

useEffect(()=>{
    if(type && types.length > 0){
    onChange("templateId", getTemplateIdFromCode(type))
    if(hasSubtype(type)){
        if(!selectedSubtypeBelongsToType()){
            onChange("subtype", "")
        }
        setMtrSubtypes([{name: "No MTR", code: `${type}`}, {name: "MTR", code: `${type}_mtr`}])
    }
    if(type === DocumentationRequestTypes.ITV_BOND && factoryActive){
        contract?.plate && dispatch(getFactoryITVBond({query: `?plate=${contract.plate}`}));
    }
    else {
        dispatch(clearITVBondInfo());
    }
    }
},[type, types])

async function fetchProvinceFromPostalCode(postalCode){
    let province;
    try {
        province = await baseRequest({param: postalCode }, dispatch, QUERY_GET_PROVINCE_BY_POSTALCODE, "GET");
    } catch (error) {
        province = null
        onChange("province", null)
        setStations([])
    }
    
    return province
}

async function setProvince(){
    if(!dataForm?.postalCode || dataForm?.postalCode.length < 5 ){
        onChange("province", null); 
        onChange("stationId", null);
        return
    }

    const province = await fetchProvinceFromPostalCode(dataForm?.postalCode);
    
    if(province){
        const provinceHasNewValue = province.name !== dataForm?.province
        if(provinceHasNewValue){
            onChange("stationId", null)
        }
        onChange("province", province.name)
        fetchStations(dataForm?.postalCode)
    } else {
        onChange("stationId", null)
    }
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}

async function fetchStations(postalCode){

    try {
        const stations = await baseRequest({param: postalCode }, dispatch, QUERY_GET_ITVS_BY_POSTAL_CODE, "GET")
        if(stations){
            setStations(stations)
        }
    } catch (error) {
        dispatch(openModal({type: "error", message: "No se han podido cargar las ITVs"}))
    }
 

}

function getTemplateIdFromCode(code){
    const {id} = types.find(type=> type.code === code)
    return  id
}

function hasSubtype(type){
    const hasSubtype = DocumentationRequestWithSubtypes.some(templateWithSubtypes=> templateWithSubtypes === type) 
    return hasSubtype
}

function selectedSubtypeBelongsToType(){
    const subtypes = getSubtypes(type)
    return subtypes.some(subtype=> subtype.code === dataForm.subtype) 
}

function getSubtypes(type){
    switch(type){
        case DocumentationRequestTypes.ORIGINAL:
            return mtrSubtypes;
        case DocumentationRequestTypes.PRODUCER_BOOK:
            return producerBookSubtypes;
        case DocumentationRequestTypes.NO_ACCIDENT_RATE_CERTIFICATE:
            return accidentRateSubtypes;
        case DocumentationRequestTypes.TELEMATIC_COPY:
            return mtrSubtypes;
        case DocumentationRequestTypes.INVOICE_DUPLICATE:
            return mtrSubtypes;
        case DocumentationRequestTypes.ORIGINAL_DUPLICATE:
            return mtrSubtypes
        default:
            return [];
    }
}

function setItvBondQueryOnly(value){
    if (value === true) {
        onChange("subtype", "itv_bond_query_only");
        onChange ("aaff", null);
    } else {
        if (dataForm.subtype === "itv_bond_query_only"){
            onChange("subtype", null) 
        }
    }
    onChange ("queryOnly", value)
}

function setItvAAFF(value){
    if(!dataForm.queryOnly){
        if (value === "Junta Extremadura"){
            onChange("subtype", "itv_bond_aaff")
        } else {
            if(dataForm.subtype === "itv_bond_aaff"){
                onChange("subtype", null)
            }
        }
    }
    onChange ("aaff", value)
}

    return(
        <div className={classes.containers} id="documentation-request-form">
            <SelectBox  label={"Tipología"} searchEnabled disabled={typesLoading === "loading"} value={type} onValueChanged={(e) => {setType(e.value); onChange("templateCode", e.value)}} valueExpr={"code"} displayExpr="name" placeholder="" dataSource={types} ></SelectBox>
            <>
            {hasSubtype(type) && 
                    <SelectBox label={"Diferenciador"} value={dataForm?.subtype} onValueChanged={(e) => onChange("subtype",e.value)} valueExpr={"code"} displayExpr={"name"} placeholder="" dataSource={getSubtypes(type)} ></SelectBox>
            }
            {type === DocumentationRequestTypes.ITV_BOND  &&
                <>
                <div className="grid-three-columns">
                    <div className="template-checkbox-container">
                        <CheckBox key={"queryOnly"} name="queryOnly" disabled={!factoryActive} value={dataForm?.queryOnly?dataForm?.queryOnly:false} onValueChanged={(e) => setItvBondQueryOnly(e.value)}></CheckBox>
                        <label>Solo consulta</label>
                    </div>
                    <SelectBox label={"Decisión"} disabled={Boolean(dataForm?.queryOnly)} value={dataForm?.aaff} onValueChanged={(e) => setItvAAFF(e.value)} placeholder="" dataSource={aafTypes} ></SelectBox>
                    <SelectBox label={"Itv"} disabled={!factoryActive} dataSource={itvTypes} onValueChanged={(e)=>onChange("itvType",e.value)} value={dataForm?.itvType}/>
                </div>
                <div className="grid-two-columns">
                        <TextBox label={"Código postal"} labelMode="floating" maxLength={5} key={"postalCode"} name="postalCode" value={dataForm?.postalCode} onFocusOut={()=>setProvince()}  onValueChanged={(e) => onChange("postalCode", e.value)}  ></TextBox>
                        <TextBox label={"Provincia"} labelMode="floating" disabled key={"province"} name="province" value={dataForm?.province}  ></TextBox>
                </div>
                <div className={"grid-four-columns"}>
                    <TextBox label={"F. Matriculación"} labelMode="floating" disabled={!factoryActive} readOnly maxLength={5} key={"registerDate"} name="registerDate" value={itvBondInfo?.registrationDate}  ></TextBox>
                    <TextBox label={"Último bono enviado"} labelMode="floating" disabled={!factoryActive}  readOnly key={"lastSentBond"} name="lastSentBond" value={itvBondInfo?.lastSentBond}  ></TextBox>
                    <TextBox label={"F. Ultima ITV"} labelMode="floating" disabled={!factoryActive}  readOnly maxLength={5} key={"lastITVDate"} name="lastITVDate" value={itvBondInfo?.lastITVDate}  ></TextBox>
                    <TextBox label={"F. Próxima ITV"} labelMode="floating" disabled={!factoryActive}  readOnly key={"nextITVDate"} name="nextITVDate" value={itvBondInfo?.nextITVDate}  ></TextBox>
                </div>
                </>      
             }
             {(type === DocumentationRequestTypes.ORIGINAL || type === DocumentationRequestTypes.ORIGINAL_DUPLICATE ||type === DocumentationRequestTypes.ENVIRONMENTAL_STICKER ||type === DocumentationRequestTypes.PRODUCER_BOOK || type === DocumentationRequestTypes.RESIDENT_CARD || type === DocumentationRequestTypes.EUROPEAN_PART ) &&  
                    <TextBox label={type === DocumentationRequestTypes.ORIGINAL ? "Dirección (incluir CP, Localidad y Provincia)" : "Dirección"} labelMode="floating" key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)}  ></TextBox>
            }
            <div className={"grid-two-columns"}>
                    <TextBox label={"Nome"} labelMode="floating" key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)}  ></TextBox>
                    <TextBox label={"Apellidos"} labelMode="floating" key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)}  ></TextBox>
                </div>

            <div className={[DocumentationRequestTypes.ZERO_EMISION_CERTIFICATE, DocumentationRequestTypes.ORIGINAL_DUPLICATE, DocumentationRequestTypes.ORIGINAL, DocumentationRequestTypes.INSURANCE_OTHER, DocumentationRequestTypes.ENVIRONMENTAL_STICKER].some(t=> t === type) ? "grid-three-columns" : "grid-two-columns"}>
            {(type === DocumentationRequestTypes.NO_ACCIDENT_RATE_CERTIFICATE || type=== DocumentationRequestTypes.FACTORY_PROCESS_DRIVER_CHANGE || type=== DocumentationRequestTypes.INSURANCE_OTHER || type=== DocumentationRequestTypes.CONECTIVITY || type === DocumentationRequestTypes.ORIGINAL_DUPLICATE || type === DocumentationRequestTypes.ORIGINAL || type === DocumentationRequestTypes.ZERO_EMISION_CERTIFICATE || type === DocumentationRequestTypes.RESIDENT_CARD ) && 
                <TextBox label={"DNI"} labelMode="floating" key={"dni"} name="dni" value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)}  ></TextBox>
            }
            { (type !== DocumentationRequestTypes.RESIDENT_CARD && type !== DocumentationRequestTypes.NO_ACCIDENT_RATE_CERTIFICATE) &&
                    <TextBox label={"Móvil"} labelMode="floating" key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}}  ></TextBox>
            }
            { (type !== DocumentationRequestTypes.ENVIRONMENTAL_STICKER && type !== DocumentationRequestTypes.PRODUCER_BOOK) &&<TextBox label={"Correo electrónico"} labelMode="floating" key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)}  ></TextBox>}
            
            <>
            { type === DocumentationRequestTypes.ORIGINAL_DUPLICATE &&
                <div className="template-checkbox-container">
                    <CheckBox key={"inform"} name="inform" value={dataForm?.inform?dataForm?.inform:false} onValueChanged={(e) => onChange("inform", e.value)}></CheckBox>
                    <label>Informado costes</label>
                </div>
            }
            {  type === DocumentationRequestTypes.ORIGINAL &&
                    <SelectBox label={"Tipo"} value={dataForm?.originalVhDocType} onValueChanged={(e) => onChange("originalVhDocType",e.value)} placeholder="" dataSource={originalVhTypes} ></SelectBox>
            }
            </>

            {
                type === DocumentationRequestTypes.ENVIRONMENTAL_STICKER &&
                <>
                    <TextBox label={"Motivo"} labelMode="floating" key={"reason"} name="reason" value={dataForm?.reason} onValueChanged={(e) => onChange("reason",e.value)}  ></TextBox>
                    <SelectBox label={"Informado de costes"} value={dataForm?.costExcempt} onValueChanged={(e) => onChange("costExcempt",e.value)} placeholder="" dataSource={costExcemptTypes} ></SelectBox>       
                </>   
            }
            </div>
            {type === DocumentationRequestTypes.RESIDENT_CARD &&
                <div className={"grid-two-columns"}>
                    <div className="template-checkbox-container">
                        <CheckBox key={"mtr"} name="mtr" value={dataForm?.mtr? dataForm.mtr : false} onValueChanged={(e) => onChange("mtr", e.value)}></CheckBox>
                        <label>MTR</label>
                    </div>
                    <SelectBox label={"Zona"} value={dataForm?.zone} onValueChanged={(e) => onChange("zone",e.value)} placeholder="" dataSource={zoneTypes} showClearButton ></SelectBox>
                </div>
            }
            {type === DocumentationRequestTypes.ITV_BOND &&       
                    <SelectBox value={dataForm?.stationId} valueExpr={"id"} 
                        placeholder={""}
                        label={"Estación"}
                        disabled={!dataForm?.province}
                        searchEnabled
                        onValueChanged={(e) => onChange("stationId",e.value)} 
                        itemRender={(item)=><div className={classes.custom_item}> <span style={{fontWeight: "bold"}}>{item && `${item.city}`}</span>{item? `, ${item?.address ? item.address : ""} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""}</div>}
                        displayExpr={(item)=> item? `${item?.city}, ${item?.address} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""} 
                        dataSource={stations}  
                        noDataText={"No hay opciones disponibles"}>
                    </SelectBox>
            }
            {
                type === DocumentationRequestTypes.CONECTIVITY &&
                    <TextBox label={"Nome acessório"} labelMode="floating" key={"accesoryName"} name="accesoryName" value={dataForm?.accesoryName} onValueChanged={(e) => onChange("accesoryName",e.value)}  ></TextBox>
            }
            {
                type === DocumentationRequestTypes.INSURANCE_DUPLICATE &&
                <div className="template-checkbox-container">
                    <CheckBox key={"urgent"} name="urgent" value={dataForm?.urgent?dataForm?.urgent:false} onValueChanged={(e) => onChange("urgent",e.value)}   style={{marginTop: 0}}></CheckBox>
                    <label>Urgente</label>
                </div>
            }
        </>
            <TextArea label="Notas" labelMode="floating" key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)}  height={144}></TextArea>
        </div>
    )
}

export { DocumentationRequestForm }